// App.js
import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import awsconfig from "./aws-exports";
import "@aws-amplify/ui-react/styles.css";

// Import Bootstrap CSS and JS directly here
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'bootstrap-icons/font/bootstrap-icons.css';

import HomePage from "./HomePage";
import VendorPage from "./VendorPage";
import UserPage from "./UserPage";
import JoinPage from "./JoinPage";
import GivePointPage from "./GivePointPage";
import RedeemRewardPage from "./RedeemRewardPage";
import Header from "./Header";
import Footer from "./Footer";

import AdminPage from "./AdminPage"; 
import VendorPortalPage from "./VendorPortalPage";  



Amplify.configure(awsconfig);

function AppRoutes({ user, signOut }) {
  return (
    // Use flex column layout to push the footer to the bottom
    <div className="d-flex flex-column min-vh-100">
      <Header user={user} signOut={signOut} />
      <main className="flex-fill">
        <div className="container">
          <Routes>
            {/* Home page: fetches groups and shows role-based links */}
            <Route path="/" element={<HomePage />} />
            <Route path="/vendors" element={<VendorPage user={user} signOut={signOut} />} />
            <Route path="/users" element={<UserPage user={user} signOut={signOut} />} />
            <Route path="/card/join" element={<JoinPage user={user} signOut={signOut} />} />
            <Route path="/card/give-point" element={<GivePointPage user={user} signOut={signOut} />} />
            <Route path="/card/redeem" element={<RedeemRewardPage user={user} signOut={signOut} />} />
            <Route path="/admin" element={<AdminPage user={user} signOut={signOut} />} />
            <Route path="/vendor_portal" element={<VendorPortalPage user={user} signOut={signOut} />} />
            {/* Any unknown route redirects to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Authenticator socialProviders={["google"]}>
        {({ user, signOut }) => <AppRoutes user={user} signOut={signOut} />}
      </Authenticator>
    </BrowserRouter>
  );
}

export default App;
